//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const isDefaultVisible = ref(true)
    const isPrimaryVisible = ref(true)
    const isSecondaryVisible = ref(true)
    const isSuccessVisible = ref(true)
    const isInfoVisible = ref(true)
    const isWarningVisible = ref(true)
    const isErrorVisible = ref(true)

    return {
      isDefaultVisible,
      isPrimaryVisible,
      isSecondaryVisible,
      isSuccessVisible,
      isInfoVisible,
      isWarningVisible,
      isErrorVisible,
    }
  },
}
